/// *** System import ***///
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { EnvironmentsModule } from './environment-variables/environment-variables.module';
import { IonicStorageModule } from '@ionic/storage';
import * as CryptoJS from 'crypto-js';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { HttpModule } from '@angular/http';
import { MyApp } from './app.component';
/// *** Providers ***///
import { Globals } from './globals';
import { SessionProvider } from '../providers/session';
/// *** ServerHubs ***///
import { MainHubProvider } from '../providers/serverHubs/main';
import { MarketSessionHubProvider } from '../providers/serverHubs/marketSession';
import { InstrumentHubProvider } from '../providers/serverHubs/instrument';
import { TradingHubProvider } from '../providers/serverHubs/trading';
/// *** Processes ***///
import { MainProcessProvider } from '../providers/processes/main';
import { TradingProcessProvider } from '../providers/processes/trading';
/// *** Stores ***///
import { Account_UserProfileStore } from '../pages/account/userProfile/userProfile.store';
import { Account_PortfolioStore } from '../pages/account/portfolio/portfolio.store';
import { Account_TransactionHistoryStore } from '../pages/account/transactionHistory/transactionHistory.store';
import { Account_NewsStore } from '../pages/account/news/news.store';
import { Market_SessionStore } from '../pages/market/session/session.store';
import { Market_SessionInstrumentStore } from '../pages/market/sessionInstrument/sessionInstrument.store';
import { Trading_OrderStore } from '../pages/trading/order/order.store';
import { Trading_OrderBookStore } from '../pages/trading/orderBook/orderBook.store';
import { Trading_OrderHistoryStore } from '../pages/trading/orderHistory/orderHistory.store';
/// *** Popovers ***///
import { Account_PortfolioParamsPopover } from '../pages/account/portfolio/popovers/params/params';
import { Account_PortfolioSortPopover } from '../pages/account/portfolio/popovers/sort/sort';
import { Account_TransactionHistoryParamsPopover } from '../pages/account/transactionHistory/popovers/params/params';
import { Account_NewsParamsPopover } from '../pages/account/news/popovers/params/params';
import { Market_SessionParamsPopover } from '../pages/market/session/popovers/params/params';
import { Market_SessionSortPopover } from '../pages/market/session/popovers/sort/sort';
import { Trading_OrderHistoryParamsPopover } from '../pages/trading/orderHistory/popovers/params/params';
/// *** Pages ***///
import { LoginPage } from '../pages/login/login';
import { ChangePasswordPage } from '../pages/account/changePassword/changePassword';
import { Account_UserProfilePage } from '../pages/account/userProfile/userProfile';
import { Account_PortfolioPage } from '../pages/account/portfolio/portfolio';
import { Account_TransactionHistoryPage } from '../pages/account/transactionHistory/transactionHistory';
import { Account_NewsPage } from '../pages/account/news/news';
import { Market_SessionPage } from '../pages/market/session/session';
import { Market_SessionInstrumentPage } from '../pages/market/sessionInstrument/sessionInstrument';
import { Market_SessionInstrumentDepthPage } from '../pages/market/sessionInstrument/depth/depth';
import { Market_SessionInstrumentIntradayPage } from '../pages/market/sessionInstrument/intraday/intraday';
import { Market_SessionInstrumentTradesPage } from '../pages/market/sessionInstrument/trades/trades';
import { Market_SessionInstrumentHistoryPage } from '../pages/market/sessionInstrument/history/history';
import { Trading_OrderPage } from '../pages/trading/order/order';
import { Trading_OrderBookPage } from '../pages/trading/orderBook/orderBook';
import { Trading_OrderHistoryPage } from '../pages/trading/orderHistory/orderHistory';
import { HelpPage } from '../pages/account/help/help';

@NgModule({
  declarations: [
    MyApp,
    // *** Popovers
    Account_PortfolioParamsPopover,
    Account_PortfolioSortPopover,
    Account_TransactionHistoryParamsPopover,
    Account_NewsParamsPopover,
    Market_SessionParamsPopover,
    Market_SessionSortPopover,
    Trading_OrderHistoryParamsPopover,
    // *** Pages
    LoginPage,
    ChangePasswordPage,
    Account_UserProfilePage,
    Account_PortfolioPage,
    Account_TransactionHistoryPage,
    Account_NewsPage,
    Market_SessionPage,
    Market_SessionInstrumentPage,
    Market_SessionInstrumentDepthPage,
    Market_SessionInstrumentIntradayPage,
    Market_SessionInstrumentTradesPage,
    Market_SessionInstrumentHistoryPage,
    Trading_OrderPage,
    Trading_OrderBookPage,
    Trading_OrderHistoryPage,
    HelpPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: ''
    }),
    IonicStorageModule.forRoot({
      name: '__MicroBrokerMobileStore',
      driverOrder: ['websql','sqlite','indexeddb']
    }),
    EnvironmentsModule,
    NgxDatatableModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    // *** Popovers
    Account_PortfolioParamsPopover,
    Account_PortfolioSortPopover,
    Account_TransactionHistoryParamsPopover,
    Account_NewsParamsPopover,
    Market_SessionParamsPopover,
    Market_SessionSortPopover,
    Trading_OrderHistoryParamsPopover,
    // *** Pages
    LoginPage,
    ChangePasswordPage,
    Account_UserProfilePage,
    Account_PortfolioPage,
    Account_TransactionHistoryPage,
    Account_NewsPage,
    Market_SessionPage,
    Market_SessionInstrumentPage,
    Market_SessionInstrumentDepthPage,
    Market_SessionInstrumentIntradayPage,
    Market_SessionInstrumentTradesPage,
    Market_SessionInstrumentHistoryPage,
    Trading_OrderPage,
    Trading_OrderBookPage,
    Trading_OrderHistoryPage,
    HelpPage
  ],
  providers: [
    // *** System
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    /// *** Providers
    Globals,
    SessionProvider,
    /// *** ServerHubs
    MainHubProvider,
    MarketSessionHubProvider,
    InstrumentHubProvider,
    TradingHubProvider,
    /// *** Processes
    MainProcessProvider,
    TradingProcessProvider,
    /// *** Stores
    Account_UserProfileStore,
    Account_PortfolioStore,
    Account_TransactionHistoryStore,
    Account_NewsStore,
    Market_SessionStore,
    Market_SessionInstrumentStore,
    Trading_OrderStore,
    Trading_OrderBookStore,
    Trading_OrderHistoryStore,
    
  ]
})
export class AppModule {
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts